<template lang="pug">
v-row
  v-col
    v-tabs(
      v-model="tab"
      :background-color="$vuetify.theme.dark ? '#303030' : 'white'"
      :color="$vuetify.theme.dark ? 'white' : 'secondary'"
      show-arrows
    ).mb-3
      v-tabs-slider

      v-tab(
        v-for="t in tabs"
        :key="t.id"
      ) {{ t.name }}
    v-tabs-items(:value="tab")
      v-tab-item(v-for="item in tabs" :key="item.id")
        component(:is="item.component" :agreements="agreements" @delete="deleteAgreement")

</template>

<script>
import AgreementsType from '@/modules/PaymentSystem/components/AgreementsType.vue';
import Bureaucracy from '@/modules/PaymentSystem/components/Bureaucracy.vue';
import AgreementsList from '@/modules/PaymentSystem/components/AgreementsList.vue';
import { CONTRACT_TYPES } from '../constants';

const agreements = {
  [CONTRACT_TYPES.ip]: {
    day_before_course_end: 0,
    type: 1,
    is_offer: true,
    // disabled: true,
  },
  [CONTRACT_TYPES.ur]: {
    day_before_course_end: 0,
    type: 2,
    is_offer: true,
  },
  [CONTRACT_TYPES.not_offer]: {
    type: 2,
    is_offer: false,
    document: {
      url: null,
      file_name: null,
    },
  },
};

export default {
  name: 'AgreementsSettings',
  data() {
    return {
      tab: 0,
      tabs: [
        { id: 1, name: 'Типовые договоры', component: AgreementsType },
        { id: 2, name: 'Реестр договоров об образовании', component: AgreementsList },
        { id: 3, name: 'Бюрократия', component: Bureaucracy },
      ],
      agreements: { ...agreements },
    };
  },
  watch: {
    tab(val) {
      this.$router.push({ query: { tab: val } });
    },
  },
  created() {
    if (this.$route.query.tab) {
      this.tab = Number(this.$route.query.tab);
    }
    this.fetchContracts();
  },

  methods: {
    deleteAgreement(agremeentKey) {
      this.agreements[agremeentKey] = { ...agreements[agremeentKey] };
    },
    async fetchContracts() {
      this.$loader.start();
      const params = {
        params: {
          expand: 'document,preview_document',
          'search[owner_id]': this.$user.data.id,
        },
      };
      const { data } = await this.$api.contracts.getTypicalContract(params);
      data.data.forEach((cur) => {
        this.agreements[!cur.is_offer ? this.$conf.CONTRACT_TYPES.not_offer : cur.type] = cur;
      });
      this.$loader.stop();
    },
  },
};
</script>

<style scoped>

</style>
